import VueGridLayout from 'vue-grid-layout'
import {mapState, mapMutations} from 'vuex'
import {showOverlay} from "./utils/showOverlay";
//TODO разобраться с этой сракой
export const generateGrid = {
  mixins: [showOverlay],
  components: {
    // gridLayout: VueGridLayout.GridLayout,
    // gridItem: VueGridLayout.GridItem
  },
  data() {
    return {
      column: '',
      layout: [],
      rowHeight: 275,
      margin: [30, 30],
      useCssTransforms: true,
      isDraggable: true,
      isResizable: false,
      isMirrored: false,
      verticalCompact: true,
    }
  },
  filters: {
    trimDesc(val) {
      if (val.length > 100) {
        return val.slice(0, 100) + '...'
      } else {
        return val
      }
    }
  },
  computed: {
    ...mapState({
      delIndex: state => state.delIndex
    }),
    // gridBreakpoints() {
    //   return {
    //     lg: 1280,
    //     md: 1000,
    //     sm: 1000,
    //     xs: 0,
    //     xxs: 0
    //   }
    // },
    // gridCols(){
    //   return {
    //     lg: 4,
    //     md: 3,
    //     sm: 2,
    //     xs: 1,
    //     xxs: 1
    //   }
    // },
    // cols: {
    //   get() {
    //     let windowWidth = window.innerWidth;
    //     let rez = '';
    //     if (windowWidth >= 1780) {
    //       rez = 4
    //     } else if (windowWidth > 1280) {
    //       rez = 3;
    //     } else if (windowWidth > 1000) {
    //       rez = 2
    //     } else {
    //       rez = 1
    //     }
    //
    //     this.column = rez;
    //     return this.column
    //   },
    //   set(val) {
    //     this.column = val
    //   }
    // },
  },
  methods: {
    ...mapMutations({
      showDelConfirm: 'popups/delItem/SET_SHOW',
      setNameDel: 'popups/delItem/SET_NAME',
      setTypeDel: 'popups/delItem/SET_TYPE',
      setLink: 'sidebar/SET_LINK_NAME',
      setRoute: 'sidebar/SET_ROUTE_NAME',
      setDashboard: 'sidebar/SET_DASHBOARD',
      setDelIndex: 'SET_DEL_INDEX',
      setDelUsersGroup: 'users/SET_DEL_GROUP'
    }),
    // generateLayot(items) {
    //   let windowWidth = window.innerWidth;
    //   let rez = '';
    //   // let counterX = 1;
    //   // let counterY = 1;
    //
    //   if (windowWidth >= 1780) {
    //     rez = 4
    //   } else if (windowWidth > 1280) {
    //     rez = 3;
    //   } else if (windowWidth > 1000){
    //     rez = 2
    //   } else {
    //     rez = 1
    //   }
    //   this.layout = [];
    //
    //   for (let i = 0; i < items.length; i++) {
    //     let item = items[i];
    //     let x = Number(item.grid.x);
    //     let y = Number(item.grid.y);
    //     if (x >= rez) {
    //       x = x - rez;
    //       y = y + +1
    //     };
    //     this.layout.push({
    //       i: Number(item.grid.i),
    //       w: Number(item.grid.w),
    //       h: Number(item.grid.h),
    //       x: x,
    //       y: y,
    //       data: items[i],
    //       checked: false
    //     });
    //   };
    //   return this.layout;
    // },
    // regenerateOnFilterUsers(defaultItems, filter) {
    //   let grid = this.generateLayot(defaultItems);
    //   if (filter != 'all') {
    //     grid = grid.filter((item) => {
    //       switch (filter) {
    //         case('all'): {
    //           return item;
    //         }
    //           break;
    //         case('user'): {
    //           return item.data.type == 'user'
    //         }
    //           break;
    //         case ('group'): {
    //           return item.data.type == 'group'
    //         }
    //           break;
    //         case ('empty'): {
    //           if (item.data.groups) {
    //             return item.data.groups.length == 0
    //           }
    //         }
    //           break;
    //       }
    //     });
    //     let windowWidth = window.innerWidth;
    //     let rez = '';
    //     // let counterX = 1;
    //     // let counterY = 1;
    //
    //     if (windowWidth >= 1780) {
    //       rez = 4
    //     } else if (windowWidth > 1280) {
    //       rez = 3;
    //     } else if (windowWidth > 1000) {
    //       rez = 2
    //     } else {
    //       rez = 1
    //     }
    //     ;
    //     let arr = [];
    //     let x = 0,
    //       y = 0;
    //     grid.forEach((item) => {
    //       let i = item.i,
    //         h = item.h,
    //         w = item.w,
    //         data = item.data,
    //         checked = item.checked;
    //       let obj = {
    //         i,
    //         w,
    //         h,
    //         data,
    //         checked
    //       };
    //       if (x < rez) {
    //         obj.x = x;
    //         obj.y = y
    //         x++
    //       } else {
    //         y++;
    //         x = 0;
    //         obj.y = y;
    //         obj.x = x;
    //       }
    //       ;
    //       arr.push(obj)
    //     });
    //     this.layout = arr;
    //   } else {
    //     this.layout = grid
    //   }
    //   // for (let i = 0; i < items.length; i++) {
    //   //   let item = items[i];
    //   //   console.log(item);
    //   //   let i = item.i,
    //   //       h = item.h,
    //   //       w = item.w,
    //   //       data = item.data,
    //   //       checked = item.checked;
    //   //
    //   //  let obj = {
    //   //    i,
    //   //    w,
    //   //    h,
    //   //    data,
    //   //    checked
    //   //  };
    //   //   if (x < rez - 1) {
    //   //     obj.x = x;
    //   //     obj.y = y
    //   //     x++
    //   //   } else {
    //   //     y++;
    //   //     x = 0;
    //   //     obj.y = y;
    //   //     obj.x = x;
    //   //   };
    //   //
    //   //   arr.push(obj)
    //   // };
    //
    //   // console.log(arr);
    // },
    // updateLayoutOnClient(newLayout, path) {
    //   this.$store.commit(path, newLayout)
    // },
    showDel(i, name, type) {
      this.setDelIndex(i);
      this.setNameDel(name);
      this.setTypeDel(type);
      this.showOverlay(true);
      this.showDelConfirm(true);
    },
    //only users
    showDelGroup(i, name, type) {
      this.setDelIndex(i);
      this.setNameDel(name);
      this.setTypeDel(type);
      this.setDelUsersGroup(true);
      this.showOverlay(true);
      this.showDelConfirm(true);
    }
  },
}
